export const healthInsuranceTypes = {
  1: '協会けんぽ',
  2: '国保',
  3: '健保組合',
};

export const pensionInsuranceTypes = {
  1: '厚生年金',
  2: '国民年金',
};

export const employmentInsuranceTypes = {
  1: '雇用保険',
  2: '日雇保険',
  3: '適用除外',
};

export const mutualAidNotebookTypes = {
  1: '建',
  2: '中',
  3: '他',
  4: '無',
};

export const flagTypes = {
  true: '有',
  false: '無',
};

export const specialHealthCheckTypes = {
  1: '石綿',
  2: 'じん肺',
};
